<script>
import { mapActions } from 'vuex';
import { result } from 'lodash';
import { rbxAuthToken } from '../config';
import snackbarMixin from '../mixins/snackbar';
import CopyrightPage from '../shared/reybex/copyrightPage';
import DataProtectionPage from '../shared/reybex/dataProtectionPage';
import ResetPasswordDialog from './ResetPasswordDialog';
import NewPasswordDialog from './NewPasswordDialog';

export default {
  components: {
    CopyrightPage,
    DataProtectionPage,
    ResetPasswordDialog,
    NewPasswordDialog,
  },
  mixins: [snackbarMixin],
  data() {
    return {
      isLoading: false,
      isLutopUrl: false,
      isImpressumDisplayed: false,
      isResetPasswordDialogDisplayed: false,
      isDataProtectionDisplayed: false,
      isNewPasswordDialogVisible: false,
      credentials: {
        username: '',
        password: '',
      },
      error: false,
      message: '',
      user: {},
    };
  },
  created() {
    const url = window.location.origin;
    const lowerCaseUrl = url.toLowerCase();
    this.isLutopUrl = lowerCaseUrl.indexOf('lutop') !== -1;
  },
  methods: {
    ...mapActions('app', ['login']),
    ...mapActions('userDetails', ['fetchCurrentUser']),
    doLogin() {
      this.error = false;
      this.message = '';
      this.isLoading = true;

      return this.login(this.credentials)
        .then(({ data }) => {
          localStorage.setItem(rbxAuthToken, data.token);

          this.fetchCurrentUser()
            .then((response) => {
              if (response && response.data && response.data.isNewPasswordRequired) {
                this.user = response.data;
                this.isNewPasswordDialogVisible = true;
              } else {
                this.loginToApp();
              }
            });
        })
        .catch(({ response }) => {
          this.message = result(response, 'data.data.error', 'Anmeldung fehlgeschlagen. Bitte versuche es erneut!');
          this.error = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    loginToApp() {
      const path = this.$route.query.redirect || '/';

      this.$router.push(path);
    },
  },
};
</script>

<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar color="white">
            <img
              v-if="isLutopUrl"
              src="../assets/logos/LUTOP_Logo_System_Small.svg"
              width="300px"
              style="margin-top:19px"
            >

            <v-spacer />
          </v-toolbar>

          <v-card-text>
            <v-form>
              <v-text-field
                v-model="credentials.username"
                prepend-icon="person"
                @keypress.enter="doLogin"
                class="js-username-input"
                label="Benutzername"
                type="text"
              />

              <v-text-field
                v-model="credentials.password"
                prepend-icon="lock"
                class="js-password-input"
                @keypress.enter="doLogin"
                label="Passwort"
                id="password"
                type="password"
              />
            </v-form>
          </v-card-text>

          <a
            v-if="!message"
            @click="isResetPasswordDialogDisplayed = true"
            style="color: #757575; position: absolute; bottom: 56px; left: 16px; font-size: 13px;"
          >
            Passwort vergessen
          </a>

          <a
            @click="isImpressumDisplayed = true"
            style="position: absolute; bottom: 10px; left: 16px; font-size: 13px;"
          >
            Impressum |
          </a>

          <a
            @click="isDataProtectionDisplayed = true"
            style="position: absolute; bottom: 10px; left: 91px; font-size: 13px;"
          >
            Datenschutzerklärung
          </a>

          <v-toolbar-title
            v-if="error"
            class="caption js-error-title"
          >
            {{ message }}
          </v-toolbar-title>

          <a
            v-if="message"
            @click="isResetPasswordDialogDisplayed = true"
            style="color: #757575; position: absolute; bottom: 86px; left: 16px; font-size: 13px;"
          >
            Passwort vergessen
          </a>
          <v-card-actions>
            <v-spacer />

            <v-btn
              @click="doLogin"
              class="js-submit-button"
              :loading="isLoading"
              color="#26a73a"
              dark
            >
              Login
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

    <reset-password-dialog
      v-if="isResetPasswordDialogDisplayed"
      @cancel="isResetPasswordDialogDisplayed = false"
    />

    <copyright-page
      v-if="isImpressumDisplayed"
      @cancel="isImpressumDisplayed = false"
    />

    <data-protection-page
      v-if="isDataProtectionDisplayed"
      @cancel="isDataProtectionDisplayed = false"
    />

    <new-password-dialog
      v-if="isNewPasswordDialogVisible"
      :user="user"
      @changePassword="loginToApp"
      @cancel="isNewPasswordDialogVisible = false"
    />
  </v-container>
</template>
